import React, { FC } from 'react'
import { Bus } from '@/events'
import { HeaderFrame, PangramButton } from './HeaderFrame'

export const Header: FC = () => (
  <HeaderFrame
    middle={<PangramButton onClick={() => Bus.emit('pangram:prechange')} />}
  />
)
